"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BREAKPOINTS = void 0;
exports.BREAKPOINTS = {
    xl: 1365,
    lg: 989,
    md: 767,
    sm: 479,
    xs: 0
};
